import cls from 'classnames';
import Tag from 'icon/tag.svg';
import TagFill from 'icon/tag_fill.svg';
import { useScopedAtom, useScopedAtomValue } from '@lemon8/webapp-shared/component';
import { FC, useCallback } from 'react';
import { $LabelVisible, $LabelSwitcherVisible } from '../../atoms';

import './style.scss';

export const LabelVisibleSwitcher: FC = () => {
  const labelSwitcherVisible = useScopedAtomValue($LabelSwitcherVisible);
  const [labelVisible, setLabelVisible] = useScopedAtom($LabelVisible);

  const handleLabelSwitcherClick = useCallback(() => {
    setLabelVisible((raw) => !raw);
  }, []);

  return (
    <div
      className={cls('label-visible-switcher', {
        label_shown: labelVisible,
        shown: labelSwitcherVisible,
      })}
      onClick={handleLabelSwitcherClick}
    >
      {labelVisible ? <Tag /> : <TagFill />}
    </div>
  );
};
